import {Record} from 'immutable';
import {schema} from 'normalizr';

const ThreadFile = Record({
    id: null,
    mimeType: null,
    originalName: null,
    fileSize: null,
});

export const ThreadFileSchema = new schema.Entity('threadFiles');

export default ThreadFile;
